import { IconChevronDown } from '@tabler/icons-react';

interface AccordionItemProps {
  title: string;
  content: React.ReactNode;
  isOpen: boolean;
  onToggle: () => void;
}

const AccordionItem: React.FC<AccordionItemProps> = ({
  title,
  content,
  isOpen,
  onToggle,
}) => (
  <div className="mb-2">
    <button
      onClick={onToggle}
      className="flex w-full items-center justify-between rounded-lg border border-gray-300 px-4 py-3 transition-colors hover:bg-gray-50"
    >
      <span className="font-semibold text-gray-900">{title}</span>
      <IconChevronDown
        className={`h-5 w-5 text-gray-600 transition-transform ${
          isOpen ? 'rotate-180' : ''
        }`}
      />
    </button>
    {isOpen && <div className="py-4">{content}</div>}
  </div>
);

export default AccordionItem;
